import { State, Mutation } from 'vuex-simple';
import { ux1Data } from '@/Common/Utils/General/Modules';

export enum NotyType {
	error = 'error',
	info = 'info',
	warning = 'warning',
	success = 'success'
}

/**
 * Notifications (Module)
 */
export default class NotificationsModule implements App.INotificationsModule {
	@State()
	public notifications: Common.IMap<App.INoty> = {};

	@Mutation()
	public add(noty: App.INotificationOptions): void {
		const id = ux1Data.md5(Date.now().toString());

		this.notifications = {
			...this.notifications,
			[id]: { ...noty, id }
		};
	}

	@Mutation()
	public remove(id: string): void {
		const notifications = { ...this.notifications };

		delete notifications[id];

		this.notifications = notifications;
	}

	@Mutation()
	public clearNotifications(): void {
		this.notifications = {};
	}
}
